import { Inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { MenuRoutes } from "./menu-routes";
import { ENVIRONMENT } from "../../../core/token";

export class MenuConstants extends MenuRoutes {
	constructor(@Inject(ENVIRONMENT) protected environment, public translateService: TranslateService) {
		super([
			{
				icon: environment.cdnEndpoint + "assets/ic-tools.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-tools-selected.svg",
				route: "/private/tools",
				translate: translateService.stream("menuArrayTranslate.tools"),
			},
			{
				icon: environment.cdnEndpoint + "assets/ic-mytools.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-mytools-selected.svg",
				route: "/private/my-tools",
				translate: translateService.stream("menuArrayTranslate.my-tools"),
			},
			{
				icon: environment.cdnEndpoint + "assets/ic-settings.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-settings-selected.svg",
				route: "/private/settings",
				translate: translateService.stream("menuArrayTranslate.settings"),
			},
			{
				icon: environment.cdnEndpoint + "assets/ic-users.svg",
				icon_selected: environment.cdnEndpoint + "assets/ic-users-selected.svg",
				route: "/private/users-static",
				translate: translateService.stream("menuArrayTranslate.users"),
			},
		]);
	}
}
